import { Component } from '@angular/core';

@Component({
  selector: 'app-subscription-banner-trial-sole',
  templateUrl: './subscription-banner-trial-sole.component.html',
  styleUrls: ['./subscription-banner-trial-sole.component.scss'],
  standalone: false
})
export class SubscriptionBannerTrialSoleComponent {
}
